<section class="mu-home">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row">
            <div class="col-12 tp-txtpg">
              <h3>Update Pending Items</h3>
            </div>
            <div class="row py-3 mx-0 align-items-center">
              <div class="col-md-6 col-12 px-0">
                <div class="d-flex updtpndactvty-leftsidetp">
                  <h3>View Pending Items of</h3>
                  <div class="" *ngIf="activityTypeData$ | async as activeType">
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      (change)="typeChange($event.target.value)">
                      <option *ngIf="user?.userType === userType.EMPLOYEE_ADMIN"></option>
                      <option *ngFor="let data of activeType" [value]="data.code">
                        {{ data.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12 px-0">
                <div class="row justify-content-end">
                  <div class="col-md-6 col-6">
                    <div class="row mx-0">
                      <div class="col-md-3 align-self-center px-0 text-md-center">
                        <p class="mb-0">From</p>
                      </div>
                      <div class="col-md-9 align-self-center px-0 text-center">
                        <input type="date" class="form-control" [(ngModel)]="fromDate" (change)="dateSelection()" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-6">
                    <div class="row mx-0">
                      <div class="col-md-3 align-self-center px-0 text-md-center">
                        <p class="mb-0">To</p>
                      </div>
                      <div class="col-md-9 align-self-center px-0 text-center">
                        <input type="date" class="form-control" [(ngModel)]="toDate" (change)="dateSelection()" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <app-summary-data-table [options]="summaryOptions" [data]="summaryData" />
            </div>
            <div class="col-12 my-3">
              <div class="row align-items-center lastupdtpndngactv">
                <div>
                  <ul>
                    <li>
                      <p>Update the Current Status to</p>
                    </li>
                    <li>
                      <select class="form-select" aria-label="Default select example" [(ngModel)]="status">
                        <option></option>
                        <option *ngFor="let data of activityStatus" [value]="data.key">
                          {{ data.label }}
                        </option>
                      </select>
                    </li>
                    <li>
                      <p>for all selected items</p>
                    </li>
                  </ul>
                </div>
                <div class="col-md-7 col-12 mt-3">
                  <div class="mb-3">
                    <label for="description" class="form-label">Comment</label>
                    <textarea class="form-control" rows="4" [(ngModel)]="comment"></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 d-flex justify-content-end acvtypglastbtn">
                    <button type="button" class="btn-actvtytp" (click)="save()">SAVE</button>
                    <button type="button" class="btn-discard" [routerLink]="DASHBOARD_LINK">EXIT</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
